import { Helmet } from "react-helmet-async";
import type { Organization, WithContext, WebSite } from "schema-dts";

export default function StructuredDataOrganizationSchema() {
  const organization: WithContext<Organization> = {
    "@context": "https://schema.org",
    "@id": `${import.meta.env.VITE_BASE_URL}/#organization`,
    "@type": "Organization",
    address: {
      "@type": "PostalAddress",
      addressCountry: "United States",
      addressLocality: "Middletown",
      addressRegion: "DE",
      postalCode: "19702",
      streetAddress: "651 N. Broad Street, Suite 206",
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: "info@webgazer.io",
    },
    description: "Explore WebGazer for reliable uptime and cron job monitoring, plus customizable status pages. Trusted globally for enhancing website performance and uptime.",
    email: "info@webgazer.io",
    foundingDate: "2017-07-03",
    image: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#logo`,
    },
    legalName: "WebGazer, Inc.",
    logo: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#logo`,
      "@type": "ImageObject",
      height: "196",
      url: `${import.meta.env.VITE_BASE_URL}/logo-webgazer.svg`,
      width: "196",
    },
    name: "WebGazer",
    sameAs: [
      "https://github.com/WebGazerIO",
      "https://www.facebook.com/webgazerio/",
      "https://www.linkedin.com/company/webgazer",
      "https://x.com/WebGazerIO",
    ],
    url: import.meta.env.VITE_BASE_URL,
  };

  const website: WithContext<WebSite> = {
    "@context": "https://schema.org",
    "@id": `${import.meta.env.VITE_BASE_URL}/#website`,
    "@type": "WebSite",
    name: "WebGazer",
    publisher: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#organization`,
    },
    url: import.meta.env.VITE_BASE_URL,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify([organization, website])}
      </script>
    </Helmet>
  );
}
